import React from 'react'
import styled from 'styled-components'

import postImage from './post.jpg'

function Post() {
  return (
    <PostContainer>
      <PostHeader>Channel Name</PostHeader>
      <img src={postImage} width={'100%'} alt="Title" />
      <PostText>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur neque
        est, viverra vel bibendum gravida, bibendum eget neque. Curabitur ut
        gravida nisi. Curabitur feugiat eros sapien, ut volutpat lacus lobortis
        quis. Duis mattis a leo sed pellentesque. Nullam ultrices id felis ac
        varius. Integer ornare tincidunt tincidunt.
      </PostText>
    </PostContainer>
  )
}

export default Post

const PostContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 700px;
  border: 1px solid #404e53;
  margin: 20px 0;
  border-radius: 2px;
`

const PostHeader = styled.div`
  padding: 15px;
`

const PostText = styled.div`
  padding: 15px;
`
